import { api } from "assets/scripts/utilities/api-clients";

export const post = async (tradeName) => {
  const response = await api.post("/kam/trade/name", tradeName);

  return response;
};

export const index = async (options = {}) => {
  const response = await api.get(`/kam/trade/name`, options);

  return response;
};
